import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import { Nav } from "./components/Nav";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { Manifesto } from "./components/Manifesto";
import { Services } from "./components/Services";
import { Regions } from "./components/Regions";
import { VineOps } from "./components/VineOps";
import { Faq } from "./components/Faq";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import SafetyPage from "./pages/Safety";
import ServicePage from "./pages/ServicePage";
import AboutPage from "./pages/About";

const Home = () => {
  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.slice(1);
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
          else el.scrollIntoView();
        }
      }, 300);
    }
  }, []);

  return (
    <>
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Services />
        <Regions />
        <VineOps />
        <Faq />
        <Contact />
      </main>
    </>
  );
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <div className="App">
        <div className="noise-overlay" />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/safety" element={<SafetyPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services/:slug" element={<ServicePage />} />
        </Routes>
        <Footer />
        <Toaster position="bottom-right" toastOptions={{ style: { background: "#1A3626", color: "#F9F6F0", border: "1px solid #B89B67", borderRadius: 0 } }} />
      </div>
    </BrowserRouter>
  );
}

export default App;
